import { CancelToken, CancelTokenSource } from 'axios';
import { getWpsString } from '@Components/MapComponents/MapLibre/Utils';
import { AxiosClient } from '@Services/data/AxiosClient';

const Api = {
    getVectorTiles: async (folderId: string) => {
        return await AxiosClient.instance.getGeoserverData(
            '/geoserver/koru-workspace/wms',
            {
                service: 'WMS',
                version: '1.1.0',
                request: 'GetMap',
                layers: 'koru-workspace%3AgetEntitiesbyWorkPacketID',
                bbox: '-1.0%2C-1.0%2C0.0%2C0.0',
                width: 768,
                height: 768,
                srs: 'EPSG%3A4326',
                format: 'application%2Fvnd.mapbox-vector-tile',
                viewparams: `folder_id:${folderId}`,
            }
        );
    },
    getWfsData: async (
        folderIds: Array<string>,
        projectId: number,
        cancelToken?: CancelToken
    ) => {
        return await AxiosClient.instance.getGeoserverData(
            '/geoserver/koru/ows',
            {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'koru:get_entities_from_db_5',
                VIEWPARAMS: `folders:${getWpsString(
                    folderIds,
                    true
                )};project_id:${projectId}`,
                outputFormat: 'application/json',
            },
            cancelToken
        );
    },
    getSpansWfsData: async (folderId: string, projectId: number) => {
        return await AxiosClient.instance.getGeoserverData(
            '/geoserver/koru/ows',
            {
                service: 'WFS',
                version: '1.0.0',
                request: 'GetFeature',
                typeName: 'koru:get_spans_by_folder',
                VIEWPARAMS: `folder_id:${folderId};project_id:${projectId}`,
                outputFormat: 'application/json',
            }
        );
    },
};

export default Api;
